import { FunctionComponent } from "react";
import { NumericFormat } from "react-number-format";

import CurrencyDisplay from "@/app/components/currencyDisplay";
import fixImageURI from "@/app/ec/product/fixImageURI";
import ProductImage from "@/app/ec/product/productImage";
import TagFilledIcon from "public/next-public/common/icons/tag-filled-icon.svg";

import StarRating from "@/components/design-system/star-rating";
import style from "./weeklySpecialsProduct.module.scss";

const WeeklySpecialsProduct: FunctionComponent<WeeklySpecialsProductProps> = ({ product }) => {
  const savings = ((product.RetailPrice - product.BestPrice) / product.RetailPrice) * 100;
  const detailLink = product.DetailLink.charAt(0) == "/" ? product.DetailLink : "/" + product.DetailLink;

  return (
    <div
      className={`weekly-specials-product-container ${style.weeklySpecialsProductContainer}`}
      key={"certona" + product.MpId}
    >
      <div className={`weekly-specials-product ${style.weeklySpecialsProduct}`}>
        <a href={detailLink} className={style.weeklySpecialsProductImage}>
          <ProductImage src={fixImageURI(product.SmallPhotoPath as string)} alt={""} width={226} height={226} />
        </a>
        <div className={style.weeklySpecialsProductDetails}>
          <div className={style.percentageOff}>
            <TagFilledIcon height={12} width={12} />
            <span className={style.percentageOffText}>
              <NumericFormat
                value={savings}
                displayType="text"
                thousandSeparator={true}
                decimalScale={0}
                fixedDecimalScale={true}
              />
              % off
            </span>
          </div>
          <a href={detailLink} className={style.weeklySpecialsProductBrand}>
            {product.BrandName}
          </a>
          <a href={detailLink} className={style.weeklySpecialsProductTitle}>
            {product.MpName}
          </a>
          <div className={style.weeklySpecialsProductPriceBlock}>
            <a href={detailLink} className={style.weeklySpecialsProductRating}>
              <StarRating rating={product.Rating} size="small" />
              <span className={style.weeklySpecialsProductRatingsCount}>
                (<NumericFormat value={product.NumberOfGeneralRatings} displayType="text" thousandSeparator />)
              </span>
            </a>
            <a href={detailLink} className={style.weeklySpecialsProductPrice}>
              <CurrencyDisplay value={product.BestPrice} />
            </a>
            <a href={detailLink} className={style.strikeLink}>
              <span className={style.strike}>
                <CurrencyDisplay value={product.RetailPrice} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

type WeeklySpecialsProductProps = {
  product: Products.Recommendations.ProductRecommendation;
};

export default WeeklySpecialsProduct;
